import { render, staticRenderFns } from "./PacketCopier.vue?vue&type=template&id=51cbb2cc&"
import script from "./PacketCopier.vue?vue&type=script&lang=ts&"
export * from "./PacketCopier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports